// extracted by mini-css-extract-plugin
export var hideEditor = "_n3-2";
export var infoIcon = "_n3-3";
export var label = "_n3-1";
export var labelContainer = "_n3-0";
export var readonlyText = "_n3-4";